import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './POIHeader.css';
import React, { useState } from 'react';
import { get, getDictionaryItem, getGlobalDictionaryTerm } from '../../utils';
import StickyCtaAssistant from '../../utils/StickyCtaAssistant';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import closeWhite from '../../resources/icons/close-white.svg';
import chevronRight from '../../resources/icons/chevron-right.svg';
import arrowNoBorderWhite from '../../resources/icons/arrow-left-noborder-white.svg';
import { Text, RichText, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import LazyPicture from '../atoms/LazyPicture';
import Video from '../atoms/Video';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import TripAdvisor from '../atoms/TripAdvisor/TripAdvisor';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
export var POIHeader = function POIHeader(_ref) {
  var fields = _ref.fields,
    rendering = _ref.rendering,
    children = _ref.children,
    params = _ref.params;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    activeHpol = _useState2[0],
    setActiveHpol = _useState2[1];
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var addToFavAnalytics = get(fields || {}, 'data.addToFavAnalytics');
  var bookNowAnalytics = get(fields || {}, 'data.bookNowAnalytics');
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing); // eslint-disable-line
  var newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  var hasCategory = Boolean(get(fields, 'data.item.category.targetItem.title.jss.value'));
  var category = get(fields, 'data.item.category.targetItem.title.jss');
  var introText = get(fields, 'data.item.introText.jss');
  var hasIntroText = Boolean(get(fields, 'data.item.introText.jss'));
  var title = get(fields, 'data.item.title.jss');
  var hasTitle = get(fields, 'data.item.title.jss.value');
  var curatorString = get(fields, 'data.item.curators.jss.value');
  var curators = Boolean(curatorString) && JSON.parse(curatorString).curators;
  var dictionaryValues = get(fields, 'data.dictionary');
  var curatorsPhrase = getDictionaryItem(dictionaryValues, 'CuratorsRecommend');
  var curatorsPick = getDictionaryItem(dictionaryValues, 'CuratorsPick') || "CURATOR'S PICKS";
  var tripAdvisorRatingImg = get(fields, 'data.item.tripAdvisorRatingImageUrl.jss.value');
  var tripAdvisorScore = get(fields, 'data.item.tripAdvisorRating.jss.value');
  var moduleId = get(fields, 'data.item.id');
  var moduleName = get(fields, 'data.item.name');
  var recommendationClickAnalytics = fields.data.recommendationClickAnalytics;
  var mainTripadvisorReviews = get(fields, 'data.item.tripAdvisorNumberReviews.jss.value');
  var mainTripadvisorPrice = get(fields, 'data.item.tripAdvisorPriceLevel.jss.value');
  var buyLinkWebsite = get(fields, 'data.item.buyLinkWebsite.jss.value.href');
  var bookingButton = getDictionaryItem(dictionaryValues, 'BookTickets') || '';
  var renderMediaPlaceholder = function renderMediaPlaceholder() {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "media-header-general",
      rendering: rendering,
      mediaDesc: introText ? introText.value : ''
    });
  };
  var renderCurators = function renderCurators() {
    if (!curators || curators.length === 0) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "curators__block"
    }, /*#__PURE__*/React.createElement("div", {
      className: "curators__row",
      onClick: function onClick(e) {
        return showCurators(e);
      },
      onKeyPress: function onKeyPress(e) {
        if (e.which === 13 || e.which === 32) {
          e.preventDefault();
          showCurators(e);
        }
      },
      tabIndex: 0
    }, Array.from(curators) && Array.from(curators).map(function (curator, index) {
      return /*#__PURE__*/React.createElement("span", {
        className: "curators__item-link",
        key: index
      }, /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 768px)",
        srcSet: curator.Image + '&cw=24&ch=24'
      }), /*#__PURE__*/React.createElement("img", {
        className: "curators__image-item",
        src: curator.Image + '&cw=24&ch=24',
        alt: curator.Name
      })));
    })), /*#__PURE__*/React.createElement("div", {
      className: "curators__author"
    }, curatorsPick));
  };
  var showCurators = function showCurators(e) {
    e.preventDefault();
    setActiveHpol('show-hpol');
  };
  var closeCurators = function closeCurators(e) {
    e.preventDefault();
    setActiveHpol('');
  };
  var renderRecommendedCurators = function renderRecommendedCurators(nb) {
    if (!curators) {
      return null;
    }
    return curators && curators.map(function (item, index) {
      return /*#__PURE__*/React.createElement("a", {
        className: "h-curators__listing-item",
        href: item.Url,
        key: index,
        "aria-label": "Recommendation",
        "aria-labelledby": "Recommendation",
        onClick: function onClick() {
          tealiumClickFunc(tealiumMergeClickData(recommendationClickAnalytics, params), item.Name);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "h-curators__listing-img-wrap"
      }, /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 768px)",
        srcSet: item.Image + '&cw=40&ch=40'
      }), /*#__PURE__*/React.createElement("img", {
        className: "h-curators__listing-img",
        src: item.Image + '&cw=40&ch=40',
        alt: item.Name
      }))), /*#__PURE__*/React.createElement("div", {
        className: "h-curators__text"
      }, item.Name ? /*#__PURE__*/React.createElement("h2", {
        className: "h-curators__listing-name"
      }, item.Name) : '', item.Role ? /*#__PURE__*/React.createElement("div", {
        className: "h-curators__listing-type"
      }, item.Role) : ''), /*#__PURE__*/React.createElement("img", {
        className: "h-curators__listing-icon",
        src: chevronRight,
        alt: item.Name
      }));
    });
  };
  var handleBookAnalytic = function handleBookAnalytic(e) {
    tealiumClickFunc(tealiumMergeClickData(bookNowAnalytics, params), "".concat(moduleName));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, buyLinkWebsite ? /*#__PURE__*/React.createElement(StickyCtaAssistant, null) : '', /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__poi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ha__img"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-bb__wrapper header-bb__wrapper--poster-show"
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder()), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: moduleId,
    classes: 'fav-btn fav-btn-mobile',
    analyticsClick: function analyticsClick(action) {
      return tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), "".concat(action, " : ").concat(moduleName));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "poi__header-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-bb__curators"
  }, renderCurators()), /*#__PURE__*/React.createElement("div", {
    className: "ha__desc--desk"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head-content"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-medium uppercase ha__localization-x"
  }, hasCategory && /*#__PURE__*/React.createElement(Text, {
    field: category
  })), /*#__PURE__*/React.createElement("div", {
    className: "head-content__top"
  }, hasTitle && /*#__PURE__*/React.createElement(Text, {
    className: "h1 h__title",
    tag: "h1",
    field: title
  }), /*#__PURE__*/React.createElement("div", {
    className: "header__actions",
    id: "poi-header-action"
  }, buyLinkWebsite && bookingButton && /*#__PURE__*/React.createElement("a", {
    href: buyLinkWebsite,
    target: "_blank",
    "aria-label": "Booking",
    "aria-labelledby": "Booking",
    rel: "noopener noreferrer",
    className: "btn btn-primary header__book-tickets",
    title: "".concat(bookingButton, " | ").concat(newWindowLabel),
    onClick: function onClick(e) {
      return handleBookAnalytic(e);
    }
  }, bookingButton), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: moduleId,
    classes: 'fav-btn fav-btn-desktop',
    analyticsClick: function analyticsClick(action) {
      return tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), "".concat(action, " : ").concat(moduleName));
    }
  })))), hasIntroText && /*#__PURE__*/React.createElement(RichText, {
    className: "body-large",
    field: introText
  }), tripAdvisorRatingImg && /*#__PURE__*/React.createElement("div", {
    className: "header__push-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__trip-advisor"
  }, /*#__PURE__*/React.createElement(TripAdvisor, {
    imageRatingSRC: tripAdvisorRatingImg,
    score: tripAdvisorScore,
    alt: "Tripadvisor",
    tripadvisorReviews: mainTripadvisorReviews,
    tripadvisorPrice: mainTripadvisorPrice,
    reviewCaption: getDictionaryItem(dictionaryValues, 'reviews')
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "hpol ".concat(activeHpol)
  }, /*#__PURE__*/React.createElement("div", {
    className: "hpol__height"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hpol__header"
  }, /*#__PURE__*/React.createElement("span", {
    tabIndex: 0,
    className: "hpol__close-btn d-none d-md-block",
    onClick: function onClick(e) {
      return closeCurators(e);
    },
    onKeyPress: function onKeyPress(e) {
      if (e.which === 13 || e.which === 32) {
        e.preventDefault();
        closeCurators(e);
      }
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: "hpol__close-btn-img",
    src: closeWhite,
    alt: "close"
  })), /*#__PURE__*/React.createElement("span", {
    onClick: function onClick(e) {
      return closeCurators(e);
    },
    className: "hpol__back-btn d-block d-md-none"
  }, /*#__PURE__*/React.createElement("img", {
    className: "hpol__back-btn-img",
    src: arrowNoBorderWhite,
    alt: "back"
  }), "Back"), /*#__PURE__*/React.createElement(Text, {
    className: "hpol__title h2",
    tag: "h3",
    field: curatorsPhrase
  })), /*#__PURE__*/React.createElement("div", {
    className: "hpol__scroller"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-curators__listing"
  }, renderRecommendedCurators(15))))))))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "remove-padding-bottom-mob ".concat(headerCommonStyle, " ").concat(fullWidthStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(headerStyle, " ").concat(headerImageStyle, " ").concat(headerPoiStyle)
  }, children);
};
var headerCommonStyle = "h1y6yjoe";
var headerStyle = "h1hmxtj3";
var headerPoiStyle = "h167c3m4";
var ltrStyles = "le5hyuo";
var rtlStyles = "r168d7j7";
export default POIHeader;